import type { GoverningPolicy } from '../types';

/**
 * The role-gate forbid among a tool's governing policies, if any. A role gate
 * (admin-role-gate, customerless-ops-role-gate) refuses an admin level without the
 * admin role, so the tool is not granted through its level group.
 */
export function roleGateOf(rows: GoverningPolicy[]): GoverningPolicy | undefined {
  return rows.find((row) => row.effect === 'forbid' && row.id.endsWith('-role-gate'));
}

/** The one-line reading of a role gate for the Tool Manager. */
export function roleGateSummary(gate: GoverningPolicy): string {
  const roles = gate.conditionHint?.replace(/^role:\s*/, '') ?? '';
  const named = roles ? ` (${roles})` : '';
  return `Needs the admin role${named}: ${gate.id} refuses an admin level without it.`;
}
